import React from 'react'
import analyze from '@images/teachV2/analyze.svg'
import { Controller } from 'react-hook-form'
import { Input } from 'reactstrap';
import ClipLoader from "react-spinners/ClipLoader";
import { HeadingTitle } from '@ui-partents/Heading'
import { TitleNoteCommon } from '../../home/generate';

export default function FormFreeText(props) {
  const { control, watch, loadingResult } = props

  return (
    <div className="formFreeText">
      <HeadingTitle
        icon={analyze}
        title="Create New Free-Text Question"
        isLight={true}
      />
      <div className="formFreeText__form">
        <div className="formFreeText__form-input">
          <div className='input-form'>
            <TitleNoteCommon title="Question Text" required/>
            <Controller
              name="question"
              control={control}
              render={({ field }) => (
                <Input
                  type='textarea'
                  name='question'
                  placeholder="Write your question here."
                  style={{ height: '80px' }}
                  {...field}
                />
              )}
            />
          </div>
          <div className='input-form'>
            <TitleNoteCommon title="Model Answer"/>
            <Controller
              name="answer"
              control={control}
              render={({ field }) => (
                <Input
                  type='textarea'
                  name='answer'
                  placeholder="(Optional) Provide an ideal answer for this question."
                  style={{ height: '80px' }}
                  {...field}
                />
              )}
            />
          </div>
          <div className='input-form'>
            <TitleNoteCommon title="Rubrics"/>
            <Controller
              name="rubrics"
              control={control}
              render={({ field }) => (
                <Input
                  type='textarea'
                  name='rubrics'
                  placeholder="(Optional) Provide grading criteria or a scoring guide for evaluation."
                  style={{ height: '80px' }}
                  {...field}
                />
              )}
            />
          </div>
        </div>
        <button className={`${loadingResult || !watch("question") ? "disabled" : ""} formFreeText__form-button`} type="submit">
          Create
          {loadingResult && <ClipLoader color="#FFF" size={16}/>}
        </button>
      </div>
    </div>
  )
}
